import { render, staticRenderFns } from "./InkDisplay.vue?vue&type=template&id=3ce2ed0f&scoped=true"
import script from "./InkDisplay.vue?vue&type=script&lang=js"
export * from "./InkDisplay.vue?vue&type=script&lang=js"
import style0 from "./InkDisplay.vue?vue&type=style&index=0&id=3ce2ed0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce2ed0f",
  null
  
)

export default component.exports